(function () {
  function loadSlick(cb){
    function loadJS(src,id,onload){
      if(document.getElementById(id)){ onload(); return; }
      var s=document.createElement('script'); s.src=src; s.id=id; s.onload=onload; document.head.appendChild(s);
    }
    function loadCSS(href,id){
      if(document.getElementById(id)) return;
      var l=document.createElement('link'); l.rel='stylesheet'; l.href=href; l.id=id; document.head.appendChild(l);
    }
    loadCSS('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css','slick-css');
    loadJS('https://cdn.jsdelivr.net/npm/jquery@3.6.4/dist/jquery.min.js','jq',function(){
      loadJS('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js','slick-js',cb);
    });
  }

  // Drives whichever slick instance is current, so re-initialising the slider
  // does not need a rebind.
  //
  // Slick stores its instance as a plain `.slick` property on the slider DOM
  // node, so the arrows can call it directly. That matters here: the page ends
  // up with three jQuery copies (3.6.0, jquery-latest, and the 3.6.4 this file
  // loads) and slick only registers as a plugin on whichever copy was
  // window.jQuery when slick.min.js ran. Reading window.jQuery at click time
  // meant `$(wrap).slick` was often undefined by then, so the call threw and
  // the tap did nothing. The desktop arrows were unaffected because slick binds
  // those itself, with its own captured jQuery — which is why only the mobile
  // header arrows appeared dead.
  function bindNav(el, method, wrap){
    if(!el || el.dataset.psNavBound) return;
    el.dataset.psNavBound = '1';
    el.addEventListener('click', function(e){
      e.preventDefault();
      var inst = wrap && wrap.slick;
      if(inst && typeof inst[method] === 'function'){ inst[method](); return; }
      // Fallback for a slick build that does not expose the instance.
      var $ = window.jQuery;
      if($ && $.fn && $.fn.slick && $(wrap).hasClass('slick-initialized')){
        $(wrap).slick(method);
      }
    });
  }

  function initSection(root){
    var $ = window.jQuery; if(!$) return;

    var $sections = root ? $(root).find('.products-slider').addBack('.products-slider') : $('.products-slider');
    if(!$sections.length) return;

    $sections.each(function(){
      try {
        var $section = $(this);
        var $wrap     = $section.find('.slider-wrapper');
        var $prevDesk = $section.find('.products-slider__track > .ps-nav--prev');
        var $nextDesk = $section.find('.products-slider__track > .ps-nav--next');
        var $mobPrev  = $section.find('.ps-nav-mob--prev');
        var $mobNext  = $section.find('.ps-nav-mob--next');

        if(!$wrap.length) return;

        if($wrap.hasClass('slick-initialized')) {
          try { $wrap.slick('unslick'); } catch(e){}
        }

        var hasArrows = $prevDesk.length > 0 && $nextDesk.length > 0;

        $wrap.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          speed: 350,
          infinite: true,
          // Decelerating curve instead of 'ease': the slide keeps up with the
          // finger at the start of the throw and settles at the end, which is
          // what makes a touch drag read as smooth rather than rubbery.
          cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          // Slick queues swipes made while an animation is still running and
          // replays them afterwards, so quick successive flicks arrived as a
          // stutter. Dropping them lets each new swipe take over immediately.
          waitForAnimate: false,
          // Default is 5px, which fires a slide change on what was meant to be
          // a vertical scroll and yanks the track sideways mid-scroll.
          touchThreshold: 12,
          // Land on the slide the finger actually released over instead of
          // always advancing exactly one, so a long drag does not snap back.
          swipeToSlide: true,
          autoplay: false,
          arrows: hasArrows,
          prevArrow: hasArrows ? $prevDesk : undefined,
          nextArrow: hasArrows ? $nextDesk : undefined,
          responsive: [
            { breakpoint: 1280, settings: { slidesToShow: 3 } },
            { breakpoint: 900,  settings: { slidesToShow: 2 } },
            // One card, left-aligned with the section gutter, with the next
            // card peeking on the right. The peek used to come from
            // centerMode + centerPadding, which reserved that space on BOTH
            // sides — so the first slide opened with a sliver of the last
            // product (an infinite-loop clone) to its left and read as
            // starting mid-list, and every card sat ~36px inside the section
            // heading above it. The peek is now padding-right on .slick-list
            // in the stylesheet: slick sizes slides from the list's CONTENT
            // width, and overflow:hidden clips at the padding edge, so the
            // next slide shows through the padding on the right only.
            { breakpoint: 768,  settings: { slidesToShow: 1 } }
          ]
        });

        // Bound natively, and only once per button. The page ends up with three
        // jQuery copies (3.6.0, jquery-latest, and the 3.6.4 this file loads),
        // so an .off('click.ps') only ever cleared the registry of whichever
        // copy was window.jQuery at that moment — the handler bound under an
        // earlier copy survived, and one tap on the mobile arrow fired
        // slickNext twice, skipping a card.
        bindNav($mobPrev[0], 'slickPrev', $wrap[0]);
        bindNav($mobNext[0], 'slickNext', $wrap[0]);

      } catch(e) {
        console.warn('Products slider init failed:', e);
      }
    });
  }

  function initAll(){
    var $ = window.jQuery;
    if($ && $.fn && $.fn.slick){
      initSection(null);
    } else {
      // Slick script loaded but hasn't registered on jQuery yet — poll until ready
      var attempts = 0;
      var poll = setInterval(function(){
        var $j = window.jQuery;
        if($j && $j.fn && $j.fn.slick){
          clearInterval(poll);
          initSection(null);
        } else if(++attempts > 50){ // give up after ~2.5s
          clearInterval(poll);
          console.warn('Slick carousel failed to register on jQuery.');
        }
      }, 50);
    }
  }

  // Sections whose markup arrives after page load (PDP recommendations is
  // fetched and injected) can't rely on initAll's single pass, and slick may
  // still be downloading when they land. This waits for it, then inits.
  function initWhenReady(root){
    var attempts = 0;
    (function poll(){
      var $j = window.jQuery;
      if($j && $j.fn && $j.fn.slick){ initSection(root); return; }
      if(++attempts > 100) { console.warn('Slick carousel failed to register on jQuery.'); return; }
      setTimeout(poll, 50);
    })();
  }

  window.PSSlider = { init: initSection, initWhenReady: initWhenReady };

  loadSlick(initAll);

  // The Safari resize re-init that used to live here recomputed centerPadding
  // as pixels on every width change. There is no centerPadding any more — the
  // peek is CSS — and slick handles its own responsive breakpoints, so the
  // teardown/rebuild (a known source of mid-swipe jitter on mobile, where the
  // URL bar collapsing fires 'resize') is gone with it.

  document.addEventListener('shopify:section:load',    function(e){ initSection(e.target); });
  document.addEventListener('shopify:section:reorder', function(e){ initSection(e.target); });
  document.addEventListener('shopify:section:unload',  function(e){
    var $ = window.jQuery; if(!$) return;
    var $wrap = $(e.target).find('.slider-wrapper');
    if($wrap.hasClass('slick-initialized')){
      try { $wrap.slick('unslick'); } catch(err){}
    }
  });
})();
